export class Poll {
    id:string;
    name:string;
}